/**
 * Date Utility Functions
 *
 * Handles date formatting and puzzle date determination
 */

/**
 * Get today's date in YYYY-MM-DD format
 *
 * @returns Today's date string
 */
export function getTodayDate(): string {
  const today = new Date();
  return formatDate(today);
}

/**
 * Format a Date object to YYYY-MM-DD string
 *
 * @param date - Date to format
 * @returns Formatted date string
 */
export function formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

/**
 * Parse YYYY-MM-DD string to Date object
 *
 * @param dateString - Date string to parse
 * @returns Date object
 */
export function parseDate(dateString: string): Date {
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
}

/**
 * Check if a date string is valid YYYY-MM-DD format
 *
 * @param dateString - Date string to validate
 * @returns True if valid format
 */
export function isValidDateFormat(dateString: string): boolean {
  const datePattern = /^\d{4}-\d{2}-\d{2}$/;
  if (!datePattern.test(dateString)) return false;

  const date = parseDate(dateString);
  return !isNaN(date.getTime());
}
